export default {
  id: 107,
  title: 'Target #107 - Sealing Wand',
  url: 'https://cssbattle.dev/play/107',
  colors: ['#161616', '#E96A23', '#FFFFFF', '#A22015'],
  solution:
    '<a a><a b><a c><a d><a e><style>[a],[b]{background:#e96a23}body{background:#161616}a{position:fixed}[a]{bottom:0;left:190;width:20;height:120}[b]{top:129;right:120;width:70;height:40;border-radius:0 40px 5px 0}[c]{bottom:97;left:185;width:30;height:50;background:#a22015;border-radius:10px}[d]{top:120;left:170;width:60;height:60;background:radial-gradient(circle,#161616 10px,#a22015 10px 15px,#fff 15px 25px,#a22015 25px);border-radius:9in}[e]{top:132;left:130;width:53;height:12;background:#fff;border-radius:0 0 0 9in;box-shadow:15px 12px #fff,30px 24px #fff;clip-path:inset(0 0 -24px 0)}</style>',
}
